export default [
  {
    path: "/user-notifications",
    component: () => import("./moduleLayout.vue"),
    meta: { layout: "full" },
    children: [
      {
        path: "",
        name: "user-notifications",
        props: true,
        component: () => import("./pages/user-notifications/index.vue"),
        meta: {
          pageTitle: "الإشعارات",
          breadcrumb: [
            // {
            //   text: "الإشعارات",
            //   active: true,
            // },
          ],
        },
      },
    ],
  },
];
